import { Image } from 'office-ui-fabric-react/lib/Image';
import * as React from 'react';
import TxpStyle from 'txp-data/lib/schema/viewSchema/TxpStyle';
import { resolve as urlResolve } from 'url';
import TxpImages from 'txp-data/lib/schema/configSchema/TxpImages';

let styles = require('./Txp.scss');
let classNames = require('classnames/bind').bind(styles);

export interface TxpImageProps {
    entityImage: string;
    txpImages: TxpImages;
    txpStyle: TxpStyle;
}

export default class TxpImage extends React.Component<TxpImageProps, {}> {
    render() {
        const { entityImage, txpStyle, txpImages } = this.props;

        return (
            <Image
                alt=""
                role="presentation"
                className={classNames(txpStyle.imageClassName)}
                shouldFadeIn={false}
                shouldStartVisible={true}
                src={
                    txpImages.packageBaseUrl && urlResolve(txpImages.packageBaseUrl(), entityImage)
                }
            />
        );
    }
}
